export const formatNumber = (val: number, fractionDigits?: number) => {
  return Intl.NumberFormat('de-DE', {
    style: 'decimal',
    minimumFractionDigits: fractionDigits ?? 2,
    maximumFractionDigits: fractionDigits ?? 2,
  }).format(val)
}
